import styled from "@emotion/styled";
import { Box, Typography, Button } from "@mui/material";
import { colors } from "../../theme/colors";

export const FeedCard = styled(Box)`
  padding: 16px;
  border-radius: 12px;
  background: #565f6d;
  display: flex;
  flex-direction: column;
  overflow: auto;

  &.feed-panel-no-background {
    background: transparent;
    padding: 0;
    border-radius: 0;
  }
`;

export const FeedHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const FeedListContainer = styled(Box)`
  padding-right: 8px;
`;

export const FeedTitle = styled(Typography)`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.text.primary};
`;

export const FeedItem = styled(Box)<{ "data-isread"?: boolean }>`
  padding: 5px;
  border-radius: 6px;
  margin-bottom: 8px;
  background-color: ${(props) =>
    props["data-isread"] ? "transparent" : "#dde4eb"};
`;

export const FeedContent = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
`;

export const FeedText = styled(Typography)`
  font-size: 13px;
  line-height: 1.3;
  color: ${colors.text.primary};
  word-break: break-word;
  overflow-wrap: break-word;
`;

export const FeedTime = styled(Typography)`
  font-size: 11px;
  color: ${colors.text.secondary};
  margin-top: 2px;
`;

export const FeedActions = styled(Box)`
  display: flex;
  gap: 8px;
  flex-shrink: 0;
`;

export const ActionButton = styled(Button)`
  min-width: 32px;
  height: 24px;
  padding: 0;
  margin: 3px 3px 0 0;
  border-radius: 6px;
  border: 1px solid ${colors.border.light};
  color: ${colors.background.secondary};
  background-color: ${colors.primary.main};

  &:hover {
    background-color: ${colors.primary.dark};
  }
`;

export const LoadingContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px;
`;

export const ErrorContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  text-align: center;
`;

export const ErrorText = styled(Typography)`
  color: ${colors.status.error};
  margin-bottom: 16px;
`;

export const RetryButton = styled(Button)`
  text-transform: none;
`;

export const EmptyStateContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`;

export const EmptyStateText = styled(Typography)`
  color: ${colors.text.secondary};
  font-size: 14px;
  line-height: 1.5;
  max-width: 280px;
`;

export const FeedItemContent = styled(Box)`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex: 1;
  min-width: 0;
`;

export const FeedItemIcon = styled(Box)`
  margin-top: 2px;
  flex-shrink: 0;
`;

export const FeedItemText = styled(Box)`
  flex: 1;
  min-width: 0;
`;
